import { css } from "@vitality-ds/system";
export default css({
  display: "inline-flex",
  userSelect: "none",
  gap: "$xs",
  justifyContent: "center"
});